<template>
  <div
    v-if="items.length"
    :class="{
      'search-autocomplete-section': true,
      'search-autocomplete-section--new': isFFEnabled,
      'search-autocomplete-section--no-separator': !isFFEnabled && type === 'history',
    }"
  >
    <div
      v-if="label"
      :class="[
        'search-autocomplete-section__label',
        isFFEnabled && 'search-autocomplete-section__label--new',
      ]"
    >
      {{ label }}
    </div>
    <ul class="search-autocomplete-section__items">
      <SearchAutocompleteSectionItem
        v-for="item in items"
        :key="`autocomplete-item-${item.id}`"
        data-testid="SearchBoxResultItem"
        :item="item"
        :highlight="shouldHighlightResults"
        :section-type="isFFEnabled ? type : undefined"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import SearchAutocompleteSectionItem from './search-autocomplete-section-item.vue';
import type { ItemResult, DynamicResults } from '@bc/discovery/domain/search';
import { isEnabled, FeatureFlag } from '@monolith/legacy/services/features';

const isFFEnabled = isEnabled(FeatureFlag.SearchRecentBrands);

withDefaults(
  defineProps<{
    label?: string;
    type?: keyof DynamicResults;
    items?: ItemResult[];
    shouldHighlightResults?: boolean;
  }>(),
  {
    label: undefined,
    type: undefined,
    items: () => [],
    shouldHighlightResults: false,
  }
);
</script>

<style scoped lang="scss">
.search-autocomplete-section {
  &:not(&--new):not(&--no-separator):not(:last-child):after {
    @apply ds-bg-neutral-300 ds-mx-4 ds-absolute;
    content: '';
    height: 1px;
    left: 0;
    right: 0;
  }
  &__label {
    @apply ds-text-left ds-text-sm ds-mx-4 ds-my-2;
    &--new {
      @apply ds-font-bold ds-mt-3 ds-mb-1 ds-my-0;
    }
  }
  &__items {
    @apply ds-m-0 ds-p-0 ds-block;
  }
}
</style>
